const removeDocument = documentId => `mutation {
  removeDocument(documentId: "${documentId}")
}`;

export default removeDocument;



// WEBPACK FOOTER //
// ./src/components/FileUploader/queries.js